'use strict';

var ROMAnalysisPOSFilterFactory = function ROMAnalysisPOSFilterFactory(DataFilter) {
  function ROMAnalysisPOSFilter() {
    DataFilter.call(this, ['rom-analysis-loco-mode', 'rom-analysis-demand-pax-mode', 'rom-analysis-flattened-services-mode', 'rom-analysis-skinny-services-mode', 'rom-analysis-skinny-services-reference-mode'], 'filter-component', 2);
  }
  ROMAnalysisPOSFilter.prototype = Object.create(DataFilter.prototype);
  ROMAnalysisPOSFilter.prototype.filter = function (data, range) {
    range = range[0];
    var filtered = DataFilter.prototype.filter(data, range.spos, 'spos');
    return filtered;
  };
  return ROMAnalysisPOSFilter;
};
ROMAnalysisPOSFilterFactory.$inject = ['DataFilterFactory'];
module.exports = ROMAnalysisPOSFilterFactory;